import React from "react";
import styled from "styled-components";
import { Colors } from "../../config";
import Typography from "./Typography";
import StatusChip from "./StatusChip";
import dayjs from "dayjs";

const LeaveDetailsItem = ({ leave }) => {
  let startDate = dayjs(parseInt(leave?.startDate.match(/(\d+)/)[0]));
  let endDate = dayjs(parseInt(leave?.endDate.match(/(\d+)/)[0]));
  return (
    <LeaveDetailsItemContainer>
      <ItemRow>
        <ItemLeft>
          <ItemLabel>Type of Leave</ItemLabel>
          <Typography
            fontColor={Colors.brandTwo}
            fontSize={"14px"}
            fontWeight={"500"}
          >
            Business Trip Leave
          </Typography>
        </ItemLeft>
      </ItemRow>
      <ItemRow>
        <ItemLeft>
          <ItemLabel>Start Date</ItemLabel>
          <Typography
            fontColor={Colors.black}
            fontSize={"14px"}
            fontWeight={"500"}
          >
            {startDate.format("DD MMM YYYY")}
          </Typography>
        </ItemLeft>
        <ItemRight>
          <ItemLabel>End Date</ItemLabel>
          <Typography
            fontColor={Colors.black}
            fontSize={"14px"}
            fontWeight={"500"}
          >
            {endDate.format("DD MMM YYYY")}
          </Typography>
        </ItemRight>
      </ItemRow>
      <ItemRow>
        <ItemLeft>
          <ItemLabel>Total No.Of Days</ItemLabel>
          <Typography
            fontColor={Colors.black}
            fontSize={"14px"}
            fontWeight={"500"}
          >
            {leave.originalQuantityInDays} Days
          </Typography>
        </ItemLeft>
        <ItemRight>
          <ItemLabel>Status</ItemLabel>
          <StatusChip label={leave.approvalStatus} color={Colors.greenHaze} />
        </ItemRight>
      </ItemRow>
      <ItemRow>
        <ItemLeft>
          <ItemLabel>Reason</ItemLabel>
          <Typography
            fontColor={Colors.black}
            fontSize={"14px"}
            fontWeight={"500"}
          >
            {leave?.comment || ""}
          </Typography>
        </ItemLeft>
      </ItemRow>
    </LeaveDetailsItemContainer>
  );
};

const ItemLabel = styled.div`
  font-size: 12px;
  color: ${Colors.greyAsh};
  margin-bottom: 4px;
`;

const ItemRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
`;

const ItemLeft = styled.div`
  flex: 1;
  text-align: left;
  display: flex;
  flex-direction: column;
  align-items: start;
`;

const ItemRight = styled.div`
  flex: 1;
  text-align: right;
  display: flex;
  flex-direction: column;
  align-items: end;
`;

const LeaveDetailsItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0.5rem 0;
  margin-top: 0.5rem;
`;

export default LeaveDetailsItem;
